<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T21:10:57+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe Contact Form
@Last modified by:   tom
@Last modified time: 2019-06-07T13:00:25+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

NOTE:  You resgister new form submissions from domain in TELEGRAM with / command !!!
-->

<template lang="html">
  <section id="contact" class="bg-dark">
    <b-container>
      <div class="header">
        <icon
          name="envelope"
          scale="2"
        />
        <h1 class="text-white">
          {{ $t('contact.title') }}
        </h1>
        <!-- <uli horizontal labelkey="contact.tips" color="primary" class="text-center"></uli> -->
      </div>

      <responseform
        :topics="[
          { value: null, text: $t('contact.topic.placeholder') },
          { value: '01:assignment  ', text: $t('contact.topic.list.1') },
          { value: '02:presentation', text: $t('contact.topic.list.2') },
          { value: '03:career      ', text: $t('contact.topic.list.3') },
          { value: '04:press       ', text: $t('contact.topic.list.4') },
          { value: '05:other       ', text: $t('contact.topic.list.5') }
        ]"
        :topic-label="$t('contact.topic.label')"
        :event-track="['lorinthe', 'contact_form_submit_action','topic_', 0.5]"
        salutation
        firstname
        lastname
        email
        text
        reset-button
      />
    </b-container>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss">
  #contact {
    color: $primaryWhite;
    .text-muted {
      color: $primaryWhite !important;
    }
    .modal-content {
      color: $primaryDark;
    }
  }

</style>
